const PlaidAccountSubtypes = Object.freeze({
  CHECKING: 1,
  CREDIT_CARD: 2,
});

export default PlaidAccountSubtypes;
